"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _AdsUtil = require("../../utils/AdsUtil");

var _UserUtil = require("../../utils/UserUtil");

var _AdInfoPanel = require("./AdInfoPanel");

var _AdInfoPanel2 = _interopRequireDefault(_AdInfoPanel);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Ad = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Ad, _Component);

  function Ad() {
    (0, _classCallCheck3.default)(this, Ad);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Ad.__proto__ || (0, _getPrototypeOf2.default)(Ad)).call(this));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.state = {
      isOpen: false,
      isClosing: false,
      isRendered: false
    };
    return _this;
  }

  (0, _createClass3.default)(Ad, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var adId = this.props.params.adId;


      if (parseInt(adId, 10) === this.props.ad.id) {
        this.setState({
          isOpen: true,
          isRendered: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          ad = _props.ad,
          soilTypes = _props.soilTypes;

      var classNames = "ad";
      var isPrivateText = "";

      if (this.state.isOpen) {
        classNames += " ad-open";
      }

      if (this.state.isClosing) {
        classNames += " ad-closing";
      }

      if (ad.editable) {
        classNames += " ad-editable";
      }

      if (ad.visibility > 0) {
        classNames += " ad-private";
        isPrivateText = "";
      }

      if (ad.project_id > 0) {
        isPrivateText = "";
      }

      return _react2.default.createElement(
        "div",
        { className: classNames },
        _react2.default.createElement(
          "div",
          { className: "row header-js", onClick: this.handleClick },
          _react2.default.createElement(
            "div",
            { className: "col-xs-4 notice-col" },
            _react2.default.createElement(
              "b",
              null,
              isPrivateText,
              " ",
              _react2.default.createElement(
                "span",
                { className: "editable-header" },
                "OMA  - "
              ),
              " ",
              (0, _AdsUtil.getSoilTypeName)(ad, soilTypes)
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "col-xs-2 notice-col" },
            (0, _moment2.default)(ad.created_at).format("D.M.YYYY")
          ),
          _react2.default.createElement(
            "div",
            { className: "col-xs-2 notice-col" },
            ad.soil_amount,
            " t"
          ),
          _react2.default.createElement(
            "div",
            { className: "col-xs-2 notice-col" },
            ad.postal_area
          ),
          _react2.default.createElement(
            "div",
            { className: "col-xs-2 notice-col" },
            _react2.default.createElement("div", { className: "ad-arrow" })
          )
        ),
        this.renderInfoPanel()
      );
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this2 = this;

      var _state = this.state,
          isOpen = _state.isOpen,
          isRendered = _state.isRendered;

      var timeout = isOpen ? 300 : 0;

      if (!isRendered) {
        this.setState({ isRendered: true });
      }

      if (isOpen) {
        this.setState({ isClosing: true });
      }

      setTimeout(function () {
        _this2.setState({
          isOpen: !isOpen,
          isClosing: false
        });
      }, timeout);
    }
  }, {
    key: "renderInfoPanel",
    value: function renderInfoPanel() {
      var _state2 = this.state,
          isOpen = _state2.isOpen,
          isRendered = _state2.isRendered;
      var _props2 = this.props,
          user = _props2.user,
          ad = _props2.ad;


      if (!isOpen && !isRendered) {
        return null;
      }

      if (!user) {
        return _react2.default.createElement(
          "div",
          { className: "row notice-info notice-info-register" },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: "/rekisteroidy", className: "notice-info-link" },
            _react2.default.createElement(
              "b",
              null,
              "Tilaa Ammattilaisprofiili n\xE4hd\xE4ksesi ilmoituksen tarkat tiedot. Rekister\xF6idy t\xE4st\xE4."
            )
          )
        );
      } else if (!(0, _UserUtil.isPaidUser)(user)) {
        return _react2.default.createElement(
          "div",
          { className: "row notice-info notice-info-not-paid" },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: "/maksullinen-profiili", className: "notice-info-link" },
            _react2.default.createElement(
              "b",
              null,
              "Tilaa Ammattilaisprofiili n\xE4hd\xE4ksesi ilmoituksen tarkat tiedot. Tilaa t\xE4st\xE4."
            )
          )
        );
      } else {
        return _react2.default.createElement(_AdInfoPanel2.default, { ad: ad });
      }
    }
  }]);
  return Ad;
}(_react.Component), _class.propTypes = {
  ad: _react.PropTypes.object.isRequired,
  soilTypes: _react.PropTypes.array.isRequired,
  user: _react.PropTypes.object,
  params: _react.PropTypes.object.isRequired
}, _temp);
exports.default = Ad;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ads/Ad.js
 ** module id = 473
 ** module chunks = 0
 **/